import { FileJson, FileSpreadsheet, Download, ExternalLink, Loader2 } from "lucide-react";
import { Button } from "@repo/ui/button";
import { Badge } from "@repo/ui/badge";
import { useRecentOutputs } from "@/hooks/useRecentOutputs";
import { useNavigate } from "react-router-dom";
import { formatDate } from "@/lib/formatDate";

export const RecentOutputsCard = () => {
  const { files, isLoading, downloadFile } = useRecentOutputs(5);
  const navigate = useNavigate();

  return (
    <div className="card-elevated">
      <div className="p-5 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="font-semibold">Recent Outputs</h3>
          <Button size="sm" variant="ghost" onClick={() => navigate('/dashboard/exports')}>
            View All
            <ExternalLink className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </div>

      <div className="divide-y divide-border">
        {isLoading ? (
          <div className="p-8 text-center text-muted-foreground">
            <Loader2 className="w-8 h-8 mx-auto mb-2 animate-spin opacity-50" />
            <p className="text-sm">Loading files...</p>
          </div>
        ) : files.length === 0 ? (
          <div className="p-8 text-center text-muted-foreground">
            <FileJson className="w-8 h-8 mx-auto mb-2 opacity-50" />
            <p className="text-sm">No output files yet</p>
          </div>
        ) : (
          files.map((file) => (
            <div key={file.id} className="p-4 flex items-center justify-between hover:bg-muted/50 transition-colors">
              <div className="flex items-center gap-3">
                {file.type === "json" ? (
                  <div className="w-9 h-9 rounded-lg bg-accent/10 flex items-center justify-center">
                    <FileJson className="w-5 h-5 text-accent" />
                  </div>
                ) : (
                  <div className="w-9 h-9 rounded-lg bg-success/10 flex items-center justify-center">
                    <FileSpreadsheet className="w-5 h-5 text-success" />
                  </div>
                )}
                <div>
                  <p className="text-sm font-medium truncate max-w-48">
                    {file.filename}
                  </p>
                  <div className="flex items-center gap-2 mt-0.5">
                    <Badge variant="outline" className="text-xs py-0">
                      {file.adapter}
                    </Badge>
                    <span className="text-xs text-muted-foreground">
                      {formatDate(file.createdAt, { includeTime: true, includeYear: false })}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs text-muted-foreground">{file.size}</span>
                <Button 
                  size="icon" 
                  variant="ghost" 
                  className="h-8 w-8"
                  onClick={() => downloadFile(file)}
                >
                  <Download className="w-4 h-4" />
                </Button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
